module.exports = __webpack_public_path__ + "PERUVIANhome-6.3f3a9d05.png";